export const TOKEN_LOGIN = 'TOKEN_LOGIN';
export const TOKEN_AUTOLOGOUT = 'TOKEN_AUTOLOGOUT';

export const tokenLogin = (loggedIn, id) => ({ type: TOKEN_LOGIN, loggedIn, id });
export const tokenAutoLogout = payload => ({ type: TOKEN_AUTOLOGOUT, payload });
